module.exports = __webpack_public_path__ + "img/placeholder_relationshipmap.bac85940.png";